/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./QuotationView.css";
import Navbar from "../core/components/NavBar";
import UserContext from "../core/UserContext";
import Moment from "moment";
// import ReactSwitch from "react-switch";
// import PaymentPlan from "../core/components/payment-plan/PaymentPlan";
import {
  canModifyQuotation,
  processUnderwritingData,
  getUserDataFromLocalStorage,
  getPolicyClassName,
} from "../core/utils";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
// import BenefitDetails from "./benefitDetails";
import ContributionTypeCard from "./contributionTypeCard";
import apiRoutes from "../api/apiRoutes";

export const getLives = (qtn) => {
  if (qtn?.userId) {
    if (qtn?.joinLoan) {
      return qtn?.user.name + " | " + qtn?.userJoint.name;
    } else {
      return qtn?.user.name;
    }
  } else {
    if (qtn?.joinLoan) {
      return (
        qtn?.quotationFormData.main_user_name +
        " | " +
        qtn?.quotationFormData.joint_user_name
      );
    } else {
      return qtn?.quotationFormData.name;
    }
  }
};

const FlexiQuotationView = () => {
  const [quotation, setQuotation] = useState();
  const [authorized, setAuthorized] = useState();
  // const [searchParams, setSearchParams] = useSearchParams();
  const [sendingEmail, setSendingEmail] = useState(false);
  const [forwaringQuotation, setForwardingQuotation] = useState(false);
  const [updatingQuotationStatus, setUpdatingQuotationStatus] = useState(false);
  const [quotationId, setQuotationId] = useState();
  const [quotations, setQuotations] = useState([]);
  const [existingUserData, setExistingUserData] = useState();
  const [loading, setLoading] = useState(false);
  const [policyClassName, setPolicyClassName] = useState("");
  const [quotationLives, setQuotationLives] = useState("");
  const [underwritingForBothDone, setUnderwritingForBothDone] = useState(false);
  const [downloadQuotation, setDownloadQuotation] = useState(false);
  const [state, setState] = useState({
    payment_insurance_plan: "",
    loan_plan: "",
    hasChosenLoanPlan: false,
  });
  const [error, setError] = useState();
  const params = useParams();
  const { userData, setUserData } = useContext(UserContext);
  const userDataStorage = getUserDataFromLocalStorage();
  const axiosPrivate = useAxiosPrivate(userDataStorage);
  const navigate = useNavigate();
  const [userConfirmationState, setUserConfirmationState] = useState({
    userId: null,
    userJointId: null,
    isJointPolicy: true,
  });

  const getQuotationLives = (qtn) => {
    // console.log(qtn);
    if (qtn?.userId) {
      if (qtn?.joinLoan) {
        return (
          qtn?.quotationFormData?.main_user_name +
          " | " +
          qtn?.quotationFormData?.joint_user_name
        );
      } else {
        return qtn?.quotationFormData?.main_user_name;
      }
    } else {
      if (qtn?.joinLoan) {
        return (
          qtn?.quotationFormData?.main_user_name +
          " | " +
          qtn?.quotationFormData?.joint_user_name
        );
      } else {
        return qtn?.quotationFormData?.main_user_name;
      }
    }
  };

  const getDeclarationsStatusForUser = async (userId) => {
    const url = process.env.REACT_APP_API_URL + `/user/declarations/${userId}`;

    try {
      const response = await axiosPrivate.get(url);

      const declarationsForQuotation = response.data.data.filter(
        (item) => item.quotationId === quotationId
      );

      if (declarationsForQuotation.length === 0) {
        return false;
      }

      for (let i = 0; i < declarationsForQuotation.length; i++) {
        const item = declarationsForQuotation[i];
        if (item.consent) {
          return false;
        }
      }

      return true;
    } catch (err) {
      // console.log(err);
      return false;
    }
  };
  const checkKyc = async (qtn) => {
    if (qtn?.joinLoan) {
      const userDeclarationStatus = await getDeclarationsStatusForUser(
        qtn?.user?.id
      );

      const userJointDeclarationStatus = await getDeclarationsStatusForUser(
        qtn?.userJoint?.id
      );

      if (
        (!qtn?.user?.kycVerification || !userDeclarationStatus) &&
        !(
          qtn?.user?.declarationsManuallyVerified &&
          qtn?.user?.shuftiManuallyVerified
        )
      ) {
        await updateQuotationStatus({ status: "kyc" });
        navigate(`/client-kyc/${qtn?.user?.id}/${qtn?.id}/main`);
      } else if (
        (!qtn?.userJoint?.kycVerification || !userJointDeclarationStatus) &&
        !(
          qtn?.userJoint?.declarationsManuallyVerified &&
          qtn?.userJoint?.shuftiManuallyVerified
        )
      ) {
        await updateQuotationStatus({ status: "kyc" });
        navigate(`/client-kyc/${qtn?.userJoint?.id}/${qtn?.id}/joint`);
      } else {
        await updateQuotationStatus({ status: "review" });
        navigate(`/review/${qtn?.id}`);
      }
      //TODO: PEP check for joint loan
    } else if (!qtn?.joinLoan) {
      const userDeclarationStatus = await getDeclarationsStatusForUser(
        qtn?.user?.id
      );

      if (
        (!qtn?.user?.kycVerification || !userDeclarationStatus) &&
        !(
          qtn?.user?.declarationsManuallyVerified &&
          qtn?.user?.shuftiManuallyVerified
        )
      ) {
        await updateQuotationStatus({ status: "kyc" });
        navigate(`/client-kyc/${qtn?.user?.id}/${qtn?.id}/main`);
      } else {
        await updateQuotationStatus({ status: "review" });
        navigate(`/review/${qtn?.id}`);
      }
    } else {
      await updateQuotationStatus({ status: "review" });
      navigate(`/review/${qtn?.id}`);
    }
  };

  useEffect(() => {
    setQuotationId(params.id);

    getQuotationDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log({ state });
  }, [state]);

  const updateWithRefund = async (payload) => {
    const url =
      process.env.REACT_APP_API_URL +
      `/quotation/worker/with-refund/update/${params.id}`;

    try {
      // payload = { ...payload, userId: userDetails.data.id };
      const { data } = await axiosPrivate.patch(url, payload);

      if (!data.success) {
        // console.log(
        //   data.message
        //     ? data.message
        //     : "Quotation update was unsuccessful, please try again"
        // );
      } else {
        setQuotation({ ...quotation, with_refund: payload.with_refund });
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const updateQuotationStatus = async (payload) => {
    setUpdatingQuotationStatus(true);
    const url =
      process.env.REACT_APP_API_URL +
      `/quotation/worker/status-update/${params.id}`;

    try {
      payload = { ...payload, userId: quotation?.user?.id };
      const { data } = await axiosPrivate.patch(url, payload);

      setUpdatingQuotationStatus(false);

      if (!data.success) {
        // console.log(
        //   data.message
        //     ? data.message
        //     : "Quotation update was unsuccessful, please try again"
        // );
      } else {
        if (payload.status === "review") {
          navigate(`/review/${quotationId}`);
        } else {
          navigate(`/underwriting/${quotationId}/main-life`);
        }
      }
    } catch (error) {
      setUpdatingQuotationStatus(false);
      // console.log(error);
    }
  };
  const getUnderwritingDataValue = async (life, qtnId) => {
    // try {
    //   const getUnderwritingUrl =
    //     process.env.REACT_APP_API_URL + `/underwriting/${qtnId}`;
    //   const currentUnderwritingDetails = await axiosPrivate.get(
    //     getUnderwritingUrl
    //   );
    //
    //   if (currentUnderwritingDetails.data.success) {
    //     if (life === "main-life") {
    //       const fieldsFromGET = JSON.parse(
    //         currentUnderwritingDetails.data.data.underwritingData
    //       ).data.map((item) => {
    //         return { key: item.key, response: item.response };
    //       });
    //       let fieldsAsObject = {};
    //       fieldsFromGET.forEach((field) => {
    //         fieldsAsObject[field.key] = field.response;
    //       });
    //       return fieldsAsObject;
    //     } else if (life === "joint-life") {
    //       const fieldsFromGET = JSON.parse(
    //         currentUnderwritingDetails.data.data.underwritingJointData
    //       ).data.map((item) => {
    //         return { key: item.key, response: item.response };
    //       });
    //       let fieldsAsObject = {};
    //       fieldsFromGET.forEach((field) => {
    //         fieldsAsObject[field.key] = field.response;
    //       });
    //       return fieldsAsObject;
    //     }
    //   } else {
    //     return {};
    //   }
    // } catch (error) {
    //   console.log(error.response.message);
    // }
  };
  const getQuotationDetails = async (fromShadowUpdate = false) => {
    const id = params.id;
    const url =
      process.env.REACT_APP_API_URL + `${apiRoutes.viewFlexiQuotation}/${id}`;
    const userData = getUserDataFromLocalStorage();
    const userId = userData?.data?.id;

    try {
      setLoading(true);
      const response = await axiosPrivate.get(url);
      if (response.data.success === true) {
        setLoading(false);
        const _quotation = response.data.data;
        // console.log(_quotation);

        _quotation.quotationFormData = JSON.parse(_quotation.quotationFormData);

        const _loanPlan = " ";
        const _paymentInsurancePlan = _quotation?.paymentInsurancePlan;

        const totalPremium = _quotation.premiumAmount;
        _quotation.totalPremium = totalPremium;
        if (!canModifyQuotation(_quotation, userId)) {
          setAuthorized(false);
          return;
        } else {
          setAuthorized(true);
        }

        setQuotation(_quotation);
        setQuotationLives(getQuotationLives(_quotation));
        setPolicyClassName(getPolicyClassName(_quotation, _loanPlan));

        setState({
          ...state,
          payment_insurance_plan: _paymentInsurancePlan,
          loan_plan: _loanPlan,
          hasChosenLoanPlan: _paymentInsurancePlan ? true : false,
        });

        setUserConfirmationState({
          ...userConfirmationState,
          userJointId: _quotation.userJointId ? _quotation.userJointId : null,
        });
        setQuotations(_quotation.QuotationShadowTables);

        checkIfLivesHaveSuccessfullyDoneUnderwriting(_quotation);
        if (fromShadowUpdate) {
          alert("Shadow quotation is now main quotation");
        }
      }
      // console.log(response);
    } catch (error) {
      console.log({ error });
    }
  };

  const getQuotationLinkAndDownload = async (_quotation) => {
    const url =
      process.env.REACT_APP_API_URL + apiRoutes.downloadPdf + _quotation.id;

    try {
      setDownloadQuotation(true);
      const response = await axiosPrivate.get(url);

      if (response.data.success === true) {
        const pdfData = response.data.data.buffer;

        const byteCharacters = atob(pdfData);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });

        setDownloadQuotation(false);

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "quotation.pdf");
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } else {
        setDownloadQuotation(false);
      }
    } catch (error) {
      setDownloadQuotation(false);
      console.error("Error downloading quotation:", error);
    }
  };

  const forwardQuotationToCustomer = async () => {
    const url =
      process.env.REACT_APP_API_URL +
      `/flexible-plan/worker/forward/savings-loan/${params.id}`;

    const payload =
      quotation?.joinLoan === false
        ? {
            userId: null,
            userJointId: null,
            isJointPolicy: false,
          }
        : userConfirmationState;

    try {
      setForwardingQuotation(true);
      const response = await axiosPrivate.post(url, payload);

      setForwardingQuotation(false);
      if (response.data.success === true) {
        alert("client details have been successfully validated");
        navigate(0);
      }

      // console.log(response);
    } catch (error) {
      if (error.response.status === 400) {
        setError(error.response.data.message);
      } else {
        try {
          setExistingUserData({
            errorMessage: error.response.data.message,
            userId: error.response.data.data.id,
            name: error.response.data.data.name,
            email: error.response.data.data.email,
            nic: error.response.data.data.nic,
            isMainLife: error.response.data.data.isMainLife,
          });
          console.log("fowarderr", error.response.data);

          if (
            error.response.data.data.isMainLife ||
            quotation.joinLoan === false
          ) {
            console.log("iferr", error.response);
            console.log("quotationerr", quotation);
            setUserConfirmationState({
              ...userConfirmationState,
              userId: error.response.data.data.id,
              isJointPolicy: false,
            });
          } else {
            console.log("elseerr", error.response);
            setUserConfirmationState({
              ...userConfirmationState,
              userJointId: error.response.data.data.id,
              isJointPolicy: true,
            });
          }
          setForwardingQuotation(false);
          // console.log(error);
        } catch (err) {
          setForwardingQuotation(false);
        }
      }
    }
  };
  const confirmExistingUser = async () => {
    const url =
      process.env.REACT_APP_API_URL +
      `/flexible-plan/worker/forward/savings-loan/${params.id}`;

    const payload = userConfirmationState;
    try {
      setForwardingQuotation(true);
      const response = await axiosPrivate.post(url, payload);

      setForwardingQuotation(false);
      if (response.data.success === true) {
        alert("client details have been successfully validated");
        navigate(0);
      }

      // console.log(response);
    } catch (error) {
      if (error.response.status === 400) {
        setError(error.response.data.message);
      } else {
        setExistingUserData({
          errorMessage: error.response.data.message,
          userId: error.response.data.data.id,
          name: error.response.data.data.name,
          email: error.response.data.data.email,
          nic: error.response.data.data.nic,
          isMainLife: error.response.data.data.isMainLife,
        });

        if (error.response.data.data.isMainLife) {
          setUserConfirmationState({
            ...userConfirmationState,
            userId: error.response.data.data.id,
            isJointPolicy: false,
          });
        } else {
          setUserConfirmationState({
            ...userConfirmationState,
            userJointId: error.response.data.data.id,
            isJointPolicy: true,
          });
        }

        setForwardingQuotation(false);
        // console.log(error);
      }
    }
  };
  const sendQuotationAsEmail = async (_quotation) => {
    // let userId = _quotation?.user?.id ? _quotation.user.id : null;
    const url =
      process.env.REACT_APP_API_URL +
      `/flexible-plan/user/email/generate-pdf/${_quotation.id}`;

    try {
      setSendingEmail(true);
      const response = await axiosPrivate.get(url);
      console.log("res", response);
      setSendingEmail(false);
      if (response.data.success === true) {
        getQuotationDetails();
        alert("quotation has been sent to customer");
      }

      // console.log(response);
    } catch (error) {
      setSendingEmail(false);
      // console.log(error);
    }
  };

  const checkIfLivesHaveSuccessfullyDoneUnderwriting = async (qtn) => {
    let mainLifeHasPerformedUnderwriting = false;
    let jointLifeHasPerformedUnderwriting = false;

    const underwritingState = await getUnderwritingDataValue(
      "main-life",
      qtn?.id
    );
    const processedData = processUnderwritingData(underwritingState);
    if (
      !(
        (processedData.map((item) => item.status).includes("Refer to ILA") ||
          processedData
            .map((item) => item.status)
            .includes("Refer TPD to ILA") ||
          quotation?.quotationFormData?.initial_sum_assured > 8000000) &&
        !quotation.underwritingManuallyAccepted
      )
    ) {
      mainLifeHasPerformedUnderwriting = true;
    }

    if (qtn?.joinLoan === true) {
      const underwritingJointState = await getUnderwritingDataValue(
        "joint-life",
        qtn?.id
      );
      const processedJointData = processUnderwritingData(
        underwritingJointState
      );
      if (
        !(
          (processedJointData
            .map((item) => item.status)
            .includes("Refer to ILA") ||
            processedJointData
              .map((item) => item.status)
              .includes("Refer TPD to ILA") ||
            quotation?.quotationFormData?.initial_sum_assured > 8000000) &&
          !quotation.underwritingManuallyAccepted
        )
      ) {
        jointLifeHasPerformedUnderwriting = true;
      }
      if (
        jointLifeHasPerformedUnderwriting &&
        mainLifeHasPerformedUnderwriting
      ) {
        setUnderwritingForBothDone(true);
      } else {
        setUnderwritingForBothDone(false);
      }
    } else {
      if (mainLifeHasPerformedUnderwriting) {
        setUnderwritingForBothDone(true);
      } else {
        setUnderwritingForBothDone(false);
      }
    }
  };

  const [contributionType, setContributionType] = useState(
    quotation?.savingsType || "Regular"
  );
  // console.log("ctype", contributionType);

  useEffect(() => {
    if (quotation?.savingsType) {
      setContributionType(quotation.savingsType);
    }
  }, [quotation?.savingsType]);

  const contributions = [
    {
      id: 0,
      title: "Single",
      value: "single",
      singleContributionAmount: "",
      deathAmount: "",
      tpdAmount: "",
      frequency: [],
    },
    {
      id: 1,
      title: "Regular",
      value: "regular",
      regularContributionAmount: "",
      deathAmount: "",
      tpdAmount: "",
      frequency: ["monthly", "quarterly", "half-yearly", "yearly"],
    },

    {
      id: 2,
      title: "Single & Regular",
      value: "single-regular",
      singleContributionAmount: "",
      regularContributionAmount: "",
      deathAmount: "",
      tpdAmount: "",
      frequency: ["monthly", "quarterly", "half-yearly", "yearly"],
    },
  ];

  return (
    <>
      <Navbar
        name={userData ? `${userData?.data?.firstname.split(" ")[0]} ` : ""}
      />
      {authorized && (
        <div className="container">
          <h4 className="mt-4" style={{ color: "#707070" }}>
            {policyClassName}
          </h4>
          <div className="alert alert-info mt-2">
            The rates applied and premiums have been calculated based on the
            details provided. Provision of incorrect information, whether
            intentionally or unintentionally will have a direct bearing on the
            premium and the underwriting decision. Failure to disclose any facts
            may lead to the insurance contract being null and void and any
            future claim may as well be voided
          </div>
          {error && (
            <div className="alert alert-danger">
              {error}

              <button
                style={{ marginLeft: 10 }}
                onClick={() => {
                  navigate(`/quotations/${quotationId}/edit`);
                }}
                className="btn btn-danger"
              >
                Edit Quotation
              </button>
            </div>
          )}

          {existingUserData && (
            <div className="alert alert-info">
              {existingUserData.errorMessage}

              <ul>
                <li>
                  <b>Name: </b> {existingUserData.name}
                </li>
                <li>
                  <b>Email: </b>
                  {existingUserData.email}
                </li>
                <li>
                  <b>NIC Number: </b>
                  {existingUserData.nic}
                </li>
              </ul>
              <button
                onClick={() => {
                  confirmExistingUser();
                }}
                className="btn btn-success text-white me-3"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  navigate(`/quotations/${quotationId}/edit`);
                }}
                className="btn btn-info text-white"
              >
                Change
              </button>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center tw-mb-4">
            <a
              className="ila-grey-link"
              href={`${process.env.REACT_APP_BASENAME}/quotations`}
            >
              <span className="fa fa-chevron-left me-2 my-4"></span>
              Back to my Quotations
            </a>

            {quotation && (
              <div>
                {quotation.isForwardedToCustomer && <></>}
                {quotation.isForwardedToCustomer &&
                  // quotation.quotationFormData.join_loan &&
                  // quotation.user &&
                  // quotation.user.kycVerification &&
                  // quotation.userJoint &&
                  // quotation.userJoint.kycVerification &&

                  // initially was only conditioned with !underwritingForBothDone
                  (underwritingForBothDone ||
                    quotation?.underwritingManuallyAccepted) && (
                    <a
                      className="btn ila-primary-btn"
                      type="button"
                      onClick={() =>
                        updateQuotationStatus({ status: "underwriting" })
                      }
                    >
                      {updatingQuotationStatus && (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                      Perform Underwriting
                    </a>
                  )}
              </div>
            )}
          </div>

          {quotation && (
            <section className="">
              <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-start tw-justify-between tw-gap-4">
                <div>
                  <h5 className="mb-2" style={{ color: "#707070" }}>
                    {quotation.permanentId
                      ? `Policy Number: ${quotation.permanentId}`
                      : `Temporary ID: ${quotation.temporaryId}`}
                  </h5>
                  <h5 className="mb-2" style={{ color: "#707070" }}>
                    Lives: {quotationLives}
                  </h5>
                  <h5 className="mb-2" style={{ color: "#707070" }}>
                    Term: {quotation.termNumber} {quotation.termOption}
                  </h5>

                  <h5 style={{ color: "#707070" }}>
                    <span className="mb-2">Creation Date: </span>
                    {Moment(quotation.createdAt).format("LL")}
                  </h5>
                  <h5 style={{ color: "#707070" }}>
                    <span className="mb-2">Expiry Date: </span>
                    {Moment(quotation.createdAt).add(15, "days").format("LL")}
                  </h5>
                </div>
                <div className="d-flex flex-column align-items-start">
                  <a
                    style={{
                      color: "#BEC663",
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                    className="btn btn-text"
                    href={`${process.env.REACT_APP_BASENAME}/quotations/${quotationId}/edit`}
                  >
                    <span className="fa fa-edit me-2"></span>Edit Quotation
                  </a>
                  <a
                    style={{
                      color: "#707070",
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                    className={`btn btn-text ${
                      !quotation.isForwardedToCustomer ? "disabled" : ""
                    }`}
                    onClick={() => {
                      getQuotationLinkAndDownload(quotation);
                    }}
                  >
                    {downloadQuotation && (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}{" "}
                    <span className="fa fa-file-pdf me-2"></span>Download as PDF
                  </a>
                  <a
                    style={{
                      color: "#707070",
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                    className="btn btn-text"
                    href={`${process.env.REACT_APP_BASENAME}/clients/${quotationId}`}
                  >
                    <span className="fa fa-user me-2"></span>View Contract
                    Partners
                  </a>
                  <a
                    style={{
                      color: "#707070",
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                    className={`btn btn-text ${
                      !quotation.isForwardedToCustomer ? "disabled" : ""
                    }`}
                    onClick={() => {
                      if (state.hasChosenLoanPlan) {
                        sendQuotationAsEmail(quotation);
                      } else {
                        alert("Please select a loan plan");
                      }
                    }}
                  >
                    {sendingEmail && (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}{" "}
                    <span className="fa fa-envelope me-2"></span>Send a copy to
                    email
                  </a>
                  <a
                    style={{
                      color: "#707070",
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                    className={`btn btn-text ${
                      quotation && quotation.isForwardedToCustomer
                        ? "disabled"
                        : ""
                    }`}
                    onClick={() => {
                      if (quotation && !quotation.isForwardedToCustomer) {
                        forwardQuotationToCustomer(quotation);
                      }
                    }}
                  >
                    {forwaringQuotation && (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}{" "}
                    <span className="fa fa-handshake me-2"></span>Validate
                    Customer
                  </a>
                </div>
              </div>
            </section>
          )}

          <section className="tw-space-y-0">
            <div className="tw-py-4 tw-space-y-4">
              <div className="tw-my-0 tw-text-black tw-text-md">
                Contribution Type
              </div>
              <select
                name="contributiontype"
                value={contributionType}
                onChange={(e) => setContributionType(e.target.value)}
                className="form-select tw-w-[300px]"
              >
                {contributions?.map((types) => (
                  <option key={types.id} value={types.value}>
                    {types.title}
                  </option>
                ))}
              </select>

              <ContributionTypeCard
                contributionType={contributionType}
                savingsType={contributionType.toLowerCase()}
                paymentPlan={quotation.quotationFormData.payment_insurance_plan}
                flexibleId={quotation.id}
                basicContribution={
                  quotation.quotationFormData.basic_contribution_amount
                }
                singleContribution={
                  quotation.quotationFormData.single_contribution_amount
                }
                sumAssured={quotation?.quotationFormData?.initial_sum_assured}
                tpdAmount={quotation.tpd}
                deathBenefitValue={quotation.death}
              />
            </div>
          </section>

          {/* New Layout */}
        </div>
      )}

      {authorized === undefined && (
        <div>
          <div className="text-center">
            <span className="spinner-border  mt-5"></span>
          </div>
          <div className="text-center">Please wait ...</div>
        </div>
      )}
      {authorized === false && (
        <div className="container">
          <div
            style={{ marginTop: 50 }}
            className="alert alert-danger"
            role="alert"
          >
            You are Unauthorized to modify this quotation
          </div>
        </div>
      )}
    </>
  );
};

export default FlexiQuotationView;
